<template>
  <div>
    <!-- <div class="buttom_style">
      <div @click="cat_href_click" class="bom_layout_style">
        <img src="./assets/img/tm.png" class="buttom_seller_style" />
        <div class="bom_font_style">天猫店</div>
      </div>
      <div @click="jd_href_click" class="bom_layout_style">
        <img src="./assets/img/jd.png" class="buttom_seller_style" />
        <div class="bom_font_style">京东店</div>
      </div>
    </div> -->
      <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { cat_href, jd_href } from "./assets/config/img";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem", "mobile"]),
  },
  data() {
    return {
     
    };
  },
  
  mounted(){
    // this.language = window.translate.language.getCurrent();
    // console.log('这里的'+ window.translate.language.getCurrent())
    // if(this.language == "english"){
    //   import('./assets/english.css');
    //   console.log('englist来了')
    // }
    // if(this.language == "japanese"){
    //   import('./assets/japanese.css');
    //   console.log('日语t来了')
    // }
    
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    rich_click() {
      const html = this.editor.getHtml();
      console.log(html);
    },
    cat_href_click() {
      window.open(cat_href);
    },
    jd_href_click() {
      window.open(jd_href);
    },
  },
};
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  color: #223344;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
}
html {
  overflow-x: hidden;
}
@media (max-width:768px) {
  body {
    overflow-x: hidden !important;
  }
  .buttom_style {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 48px;
    border-top: 1px solid #e5e9f0;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(34, 51, 68, 0.2);
  }
  .buttom_seller_style {
    width: 24px !important;
  }
  .bom_font_style {
    font-size: 12px;
  }
  .bom_layout_style {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
}
@media (min-width:768px) {
  .buttom_style {
    display: none;
  }
}
</style>
